<cc-settings-block>
  <cc-settings-header
    header="PHONE_NUMBERS.HEADER">
    <span translate>PHONE_NUMBERS.SLIDE</span>
    <ui-switch
      [(ngModel)]="numbers.restricted"
      (change)="onChangePhoneNumbers($event)"
      class="custom"></ui-switch>
  </cc-settings-header>
  <cc-settings-body *ngIf="!numbers.restricted">
    <cc-phone-number-row
      (setMainPhoneNumber)="onSetMainPhoneNumber($event)"
      (setMainEeaPhoneNumber)="onSetMainEeaPhoneNumber($event)"
      (removePhoneNumber)="onRemovePhoneNumber($event)"
      [campaignId]="campaignId"
      *ngFor="let number of numbers.campaignsMsisdns"
      [number]="number"></cc-phone-number-row>
    <form
      [formGroup]="addForm"
      class="add-phone-number">
      <div class="add-phone-number-text" translate>PHONE_NUMBERS.ADD_PHONE_NUMBER</div>
      <mat-select
        formControlName="msisdnId"
        (selectionChange)="onSelectPhoneNumber($event)"
        [placeholder]="'MAPPING.SELECT_PLACEHOLDER' | translate">
        <mat-option (click)="gotoNewNumber()">
          <span translate>MAPPING.GET_NUMBER</span>
        </mat-option>
        <mat-option
          class="cc-msisdn"
          *ngFor="let msisdn of msisdns | async"
          [value]="msisdn">
          <cc-msisdn [msisdn]="msisdn"></cc-msisdn>
        </mat-option>
      </mat-select>
    </form>
  </cc-settings-body>
  <cc-settings-footer
    header="PHONE_NUMBERS.FOOTER.HEADER"
    body="PHONE_NUMBERS.FOOTER.BODY"
  ></cc-settings-footer>
</cc-settings-block>
